import React from "react";
import logo from "../../images/icons/logo.png";
import menuIcon from "../../images/icons/menu_dark_grey32.png";
import menuIconRed from "../../images/icons/menu_red32.png";
import { Link } from "react-router";

const HeaderMobile = ({ setMenuOpen, menuOpen }) => {
  return (
    <div className="header_container">
      <div className="logo_mobile_container">
        <Link to={"/home"}>
          <img src={logo} alt="logo" className="logo" />
        </Link>
        {!menuOpen ? (
          <img
            src={menuIconRed}
            alt="menu"
            className="menu_btn"
            onClick={() => setMenuOpen(!menuOpen)}
          />
        ) : (
          <img
            src={menuIcon}
            alt="menu"
            className="menu_btn"
            onClick={() => setMenuOpen(!menuOpen)}
          />
        )}
      </div>
    </div>
  );
};

export default HeaderMobile;
